export default __webpack_public_path__ + "static/media/deligoo-sm-light.c668b1c2.svg";